import React from 'react';

import { HomepageHero } from '@/app/_components/HomepageHero';
import { HomepageHeroProps } from './types';

import classes from './index.module.scss';

export const HomepageHeroGraphQL: React.FC<HomepageHeroProps> = props => {
  const { id } = props;

  return (
    <div id={`block-${id}`} className={classes.blockWrapper}>
      <HomepageHero homepageHero={props} />
    </div>
  );
};

export default HomepageHeroGraphQL;